// Illustrazioni piatte con figure umane: usate negli stati vuoti.
// Palette calda (corallo/giallo/lavanda) coerente con le linee guida.
const C = { coral: "#FF6B6B", yellow: "#FCA311", lav: "#9D8CE0", navy: "#1A2B4A", skin: "#F3C6A5", beige: "#EFE7DC" };

function Persona({ x = 0, maglia = C.coral, pantalone = C.navy, capelli = "#2B2B3A", braccio = "su" }) {
  return (
    <g transform={`translate(${x} 0)`}>
      <rect x="26" y="96" width="12" height="34" rx="6" fill={pantalone} />
      <rect x="42" y="96" width="12" height="34" rx="6" fill={pantalone} />
      <rect x="22" y="52" width="36" height="48" rx="16" fill={maglia} />
      {braccio === "su" ? (
        <rect x="54" y="34" width="10" height="34" rx="5" fill={maglia} transform="rotate(18 59 51)" />
      ) : (
        <rect x="54" y="58" width="10" height="30" rx="5" fill={maglia} />
      )}
      <rect x="16" y="58" width="10" height="30" rx="5" fill={maglia} />
      <circle cx="40" cy="36" r="14" fill={C.skin} />
      <path d="M26 32a14 14 0 0 1 28 0c0 3-4-4-14-4s-14 7-14 4z" fill={capelli} />
      <circle cx="35" cy="37" r="1.6" fill={C.navy} />
      <circle cx="45" cy="37" r="1.6" fill={C.navy} />
      <path d="M36 43q4 3 8 0" stroke={C.navy} strokeWidth="1.6" fill="none" strokeLinecap="round" />
    </g>
  );
}

function Fumetto({ x, y, testo = "" }) {
  return (
    <g transform={`translate(${x} ${y})`}>
      <rect width="46" height="30" rx="15" fill="#fff" />
      <path d="M14 30l4 9 8-9z" fill="#fff" />
      {testo && <text x="23" y="20" textAnchor="middle" fontSize="14" fill={C.lav} fontWeight="600">{testo}</text>}
    </g>
  );
}

const Base = ({ children, testid, w = 320 }) => (
  <svg data-testid={testid} viewBox={`0 0 ${w} 200`} className="w-full max-w-[320px] h-auto mx-auto" role="img">
    <rect width={w} height="200" rx="26" fill={C.beige} />
    <ellipse cx={w / 2} cy="176" rx={w / 3} ry="10" fill="#00000010" />
    <g transform="translate(-40 12) scale(1.28)">{children}</g>
  </svg>
);

// Tutto in ordine: due persone che si salutano
export const IllustrazioneTuttoOk = () => (
  <Base testid="ill-tutto-ok">
    <Fumetto x="112" y="4" />
    <Persona x="84" maglia={C.yellow} pantalone="#3B3B5C" braccio="giu" />
    <Persona x="168" maglia={C.lav} pantalone={C.navy} capelli="#4A2E22" />
  </Base>
);

// Nessun documento ricevuto: persona con foglio in mano
export const IllustrazioneDocumenti = () => (
  <Base testid="ill-documenti">
    <rect x="156" y="28" width="34" height="44" rx="4" fill="#fff" transform="rotate(-8 173 50)" />
    <rect x="163" y="40" width="20" height="2.6" rx="1.3" fill={C.lav} transform="rotate(-8 173 50)" />
    <rect x="163" y="47" width="20" height="2.6" rx="1.3" fill={C.lav} transform="rotate(-8 173 50)" />
    <Persona x="110" maglia={C.coral} pantalone="#2F3E5C" />
  </Base>
);

// Nessun risultato: persona che si interroga
export const IllustrazioneRicerca = () => (
  <Base testid="ill-ricerca">
    <Fumetto x="150" y="4" testo="?" />
    <Persona x="96" maglia={C.lav} pantalone={C.yellow} capelli="#2B2B3A" braccio="giu" />
    <Persona x="176" maglia={C.yellow} pantalone="#3B3B5C" capelli="#4A2E22" />
  </Base>
);

export const StatoVuoto = ({ illustrazione: Ill = IllustrazioneTuttoOk, titolo, testo, testid }) => (
  <div data-testid={testid} className="py-4 text-center">
    <Ill />
    <p className="mt-3 text-sm font-medium text-[#1A2B4A]">{titolo}</p>
    {testo && <p className="mt-1 text-xs text-[#718096] max-w-sm mx-auto">{testo}</p>}
  </div>
);
